<template>
	<div class="evaluationreport">
		需求还没定，还不能测试
	</div>
</template>

<script>
import { debounce } from '@/utils/util'
import { hisSubsidy, companySearch, companyDo } from '@/api/api_home'
import { Toast } from 'vant'
export default {
	name: 'index',
	data(){
		return {
			optionSetting: {  // 首页无缝滚动交互参数
				step: 0.5, // 数值越大速度滚动越快
				limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: false, // 是否开启鼠标悬停stop
			},
			companyCount: null,
			subsidyAmountSummary: null,
			listData: [],
			popupEnterpriseName: false, // 输企业名称弹层
			enterpriseName: '', // 企业名称
			inputEnterpriseName: '', //输入框内企业名称
			loading: false,
			page: 1,
			size: 5,
			companyList: [], // 根据企业名称获取的公司名称列表
		}
	},
	watch: {
		inputEnterpriseName: function(){
			this.onSearch();
		}
	},
	mounted () {
		this.getHisSubsidy()
	},
	methods: {
		//获取首页政策企业资助列表
		async getHisSubsidy() {
			let res = await hisSubsidy()
			if(res && res.ok > 0){
				this.companyCount = res.data.companyCount
				this.subsidyAmountSummary = res.data.subsidyAmountSummary
				this.listData = res.data.subsidyList
			}
		},
		showPopupEnterpriseName() {
			this.popupEnterpriseName = true
			/* this.$nextTick(() => {
				this.$refs.enterpriseName.focus()
			}) */
		},
		selectCompany (item) {
			this.enterpriseName = item
			this.popupEnterpriseName = false
		},
		clearInputEnterpriseName() {
			this.inputEnterpriseName = ''
			this.companyList = []
		},
		onSearch() {
			debounce(this.getCompanyList, 1000)()
		},
		getCompanyList(){
			// this.loading = true
			let params = {
				companyName: this.inputEnterpriseName
			}
			companySearch(params).then((res)=>{
				// this.loading = false
				if(res && res.ok){
					this.companyList = res.data
				}
			})
		},
		showMatch() {
			if(!this.enterpriseName){
				Toast('请输入企业名称')
				return
			}
			let params = {
				companyName: this.enterpriseName
			}
			companyDo(params).then((res)=>{
				if(res && res.ok){
					this.$emit('submitCompany',res.data)
				}
			})
		}
	}
};
</script>
<style lang="less" scoped>
.noenterprise {
	&-t {
		height: 190px;
		background: @blue;
		padding: 87px 16px 0;
		color: #ffffff;
		position: relative;
		.t {
			font-size:28px;
			line-height: 28px;
		}
		.c {
			font-size: 13px;
			line-height: 14px;
			margin-top: 10px;
			position: relative;
			span {
				color: @lightYellow;
				margin: 0 5px;
				font-weight: bold;
			}
		}
		img {
			position: absolute;
			right: 11px;
			bottom: 17px;
		}
	}
	&-c {
		position: relative;
		top: -17px;
		background: #ffffff;
		border-radius:12px 12px 0px 0px;
		padding: 40px 30px 20px;
		.t {
			font-size: 16px;
			color: #333333;
			height: 30px;
			line-height: 30px;
			span{
				color: @blue;
				font-size: 40px;
				font-family: DINCondensedBold;
				margin: 0 5px;
				vertical-align: text-bottom;
			}
		}
		.enterprisename {
			margin: 38px 0 30px;
			.inputbox {
				padding: 16px 0;
				width: 100%;
				height: 52px;
				line-height: 20px;
				border: none;
				border-bottom: 1px solid #DDDDDD;
				margin-bottom: 20px;
				span{
					height: 20px;
					line-height: 20px;
					overflow: hidden;
					display: inline-block;
				}
			}
			.popup-enterprisename {
				padding: 16px 20px;
				.title {
					text-align: center;
					font-size: 18px;
					line-height: 22px;
					position: relative;
					margin-bottom: 22px;
					.define{
						position: absolute;
						top: 0;
						right: 0;
						font-size: 14px;
						line-height: 22px;
					}
				}
				.inputbox{
					position: relative;
					padding-right: 20px;
					line-height: 26px;
					height: 58px;
					margin-bottom: 0;
					input {
						width: 100%; 
						font-size: 20px;
						border: none;
					}
					.iconfont {
						font-size: 14px;
						position: absolute;
						right: 0;
						top: 18px;
					}
				}
				.companylistbox {
					.loadingbox {
						padding-top: 100px;
						text-align: center;
					}
					ul.companylist {
						height: 400px;
						overflow-y: scroll;
						li {
							font-size: 14px;
							line-height: 20px;
							padding: 15px 0;
							border-bottom: 1px solid #dddddd;
							font-size: 14px;
							color: #333333;
							span { color: @blue;}
						}
					}
				}
			}
		}
		.textswiper {
			p {
				font-size: 12px;
				line-height: 12px;
				color: #999999;
				text-align: center;
				span {
					margin: 0 auto;
					color: @blue;
				}
			}
			.seamless-warp {
				height: 150px;
				margin-top: 40px;
				overflow: hidden;
				position: relative;
				&:before {
					content: '';
					width: 100%;
					height:47px;
					background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
					position: absolute;
					left: 0;
					top: 0;
					z-index: 1;
				}
				&:after {
					content: '';
					width: 100%;
					height:44px;
					background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
					position: absolute;
					left: 0;
					bottom: 0;
				}
				ul {
					li {
						margin-bottom: 10px;
						font-size: 12px;
						line-height: 18px;
						color: #999999;
						.enterprise {
							color: #333;
						}
						.price {
							color: @priceColor;
						}
					}
				}
			}
		}
	}
}
</style>